export default __webpack_public_path__ + "static/media/step_1_do.a4bc61e0.jpg";